import { CustomerService } from "@/services/api/customer.service";

const state = {
  id: null,
  profile: null,
  events: [],
};

export default {
  namespaced: true,

  state: { ...state },

  actions: {
    loadProfile({ commit }, customerId) {
      CustomerService.getProfile(customerId).then(response => {
        commit("SET_PROFILE", response);
      });
    },
  },

  mutations: {
    SET_ID(state, id) {
      state.id = +id;
    },

    SET_EVENTS(state, items) {
      state.events = items;
    },

    SET_PROFILE(state, payload) {
      state.profile = payload;
    },
  },
};
